import styled from 'styled-components';

export const StyledControlBar = styled.div`
  position: absolute;
  display: flex;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  z-index: 1;

  #ol-control-bar {
    top: 0;
    max-width: 100%;
    margin: 0 auto;
    padding-left: 2rem;
    padding-right: 1rem;
  }
  #ol-controls-scale-line-target {
    .ol-scale-line-override {
      position: absolute;
      transform: none;
      padding: 0.5rem 0.875rem;
      box-shadow: unset;
      z-index: 2;
      left: 5%;
      bottom: 5%;
    }
    .ol-scale-line-override-inner {
      height: 1.25rem;
      line-height: 1.25rem;
      font-size: 0.75rem;
    }
  }

  #ol-controls-zoom-target {
    position: absolute;
    top: 2rem;
    right: 2rem;
    z-index: 1;

    display: flex;
    flex-direction: column;

    #ol-controls-reset-position-target {
      order: 2;
      margin-top: 1rem;

      button {
        width: 2rem;
        height: 2rem;
      }
    }

    .ol-zoom-override {
      width: 2rem;
      border: 1px solid #eaeaea;

      border-radius: 0.25rem !important;
      margin-top: 0;

      .ol-zoom-override-in,
      .ol-zoom-override-out {
        width: 2rem !important;
        height: 2.5rem !important;
        padding: 0.625rem !important;
        position: relative;

        &:before,
        &:after {
          content: '';
          display: block;
          width: 1rem;
          height: 0.25rem;
          background-color: #0d1f63;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          border-radius: 1px;
        }

        img {
          display: none;
        }
      }
      .ol-zoom-override-in {
        border-bottom: 1px solid #eaeaea;

        &:after {
          width: 0.25rem;
          height: 1rem;
        }
      }
      .ol-zoom-override-out {
        &:after {
          display: none;
        }
      }
      .ol-zoom-in-label-override,
      .ol-zoom-out-label-override {
        padding: 0 !important;
        max-width: 100% !important;
        min-width: 0 !important;
        width: 100% !important;
        border-bottom: none !important;
        margin: 0 !important;
      }
    }
  }
  #ol-controls-toolbar-button-measurements-target {
    li {
      margin-left: 0 !important;
    }
  }
`;
